import { APP } from '../actionTypes'

export interface AppState {
  userInfo: UserInfo
  region: Region
  selectedBiz: BusinessType | undefined
  userResources: UserResources
  weather?: { detail: string; temperature: string }
}

const initialState: AppState = {
  userInfo: {} as UserInfo,
  region: {} as Region,
  selectedBiz: undefined,
  userResources: [] as UserResources,
  weather: {
    detail: '',
    temperature: '',
  },
}

export default function app(state = initialState, action: Action) {
  switch (action.type) {
    case APP.UPDATE_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
